import { Injectable } from '@angular/core';

export interface OverlayZIndexToken {
  readonly token: symbol;
  readonly zIndex: number;
}

/**
 * Assigns incrementing z-indexes to overlays (modals, drawers) so that
 * whichever overlay opens last renders on top. The first overlay gets the
 * base z-index (1090, matching the existing modal value); each subsequent
 * overlay gets +10.
 */
@Injectable({ providedIn: 'root' })
export class OverlayZIndexService {
  // Must match $z-index-modal in styles/settings/_variables.scss
  private readonly BASE_Z_INDEX = 1090;
  private readonly INCREMENT = 10;
  private nextZIndex = this.BASE_Z_INDEX;
  private activeTokens = new Set<symbol>();

  acquire(): OverlayZIndexToken {
    const token = Symbol('overlay');
    const zIndex = this.nextZIndex;
    this.nextZIndex += this.INCREMENT;
    this.activeTokens.add(token);
    return { token, zIndex };
  }

  release(token: symbol): void {
    this.activeTokens.delete(token);
    if (this.activeTokens.size === 0) {
      this.nextZIndex = this.BASE_Z_INDEX;
    }
  }
}
